import { motion } from "framer-motion";
import type { SVGProps } from "react";
import { classNames } from "../../utils/classNames";

interface IProgressCircleProps extends SVGProps<SVGSVGElement> {
  progress: number;
}

const RADIUS = 45;

export function ProgressCircle({
  className,
  progress,
  ...props
}: IProgressCircleProps) {
  const circumference = Math.ceil(2 * Math.PI * RADIUS);
  const filledProgress = Math.abs(
    Math.ceil((circumference / 100) * (progress - 100)),
  );

  return (
    <div className="relative">
      <svg
        viewBox="0 0 100 100"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        height={100}
        width={100}
        data-slot="track"
        className={classNames("text-blue-500 dark:text-blue-400", className)}
        {...props}
      >
        <circle
          cx="50"
          cy="50"
          r={RADIUS}
          className="circle"
          stroke="currentColor"
          strokeOpacity="0.1"
          fill="transparent"
        />
      </svg>
      <svg
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
        height={100}
        width={100}
        data-slot="progress"
        className={classNames(
          "absolute -rotate-90 overflow-visible top-0 text-blue-500 dark:text-blue-400",
          className,
        )}
        {...props}
      >
        <motion.circle
          cx="50"
          cy="50"
          r={RADIUS}
          stroke="currentColor"
          fill="transparent"
          strokeDashoffset={filledProgress}
          strokeDasharray={circumference}
          variants={{
            progress: {
              strokeDashoffset: filledProgress,
              transition: {
                duration: 0.2,
                ease: "easeIn",
              },
            },
          }}
          initial="hidden"
          animate="progress"
        />
      </svg>
    </div>
  );
}
